<template>
  <el-dialog
    id="createTestCollectionOrderDialog"
    :title="$t('text.syncOrderStatusConfig')"
    :visible="isShowSyncOrderStatusConfigDialog"
    width="600px"
    @open="openDialog"
    @close="closeDialog"
    :close-on-click-modal="false"
  >
    <el-form
      ref="form"
      :model="form"
      label-width="170px"
      v-show="submitted === false"
    >
      <el-form-item :label="$t('text.syncOrderObject')">
        <el-radio-group v-model="form.type">
          <el-radio label="none">{{ $t("text.notSpecified") }}</el-radio>
          <el-radio label="upstream">{{ $t("text.upstream") }}</el-radio>
          <el-radio label="channel">{{ $t("text.channel") }}</el-radio>
        </el-radio-group>
      </el-form-item>

      <el-form-item
        :label="$t('text.upstream')"
        prop="upstream"
        v-if="form.type === 'upstream'"
      >
        <el-select v-model="form.upstream">
          <el-option label="EASYPAISA" value="easypaisa"></el-option>
          <el-option label="JAZZCASH" value="jazzcash"></el-option>
        </el-select>
      </el-form-item>

      <el-form-item
        :label="$t('text.channel')"
        prop="channelId"
        v-if="form.type === 'channel'"
      >
        <!-- <el-input
          v-model="form.channel"
          auto-complete="off"
          :placeholder="$t('message.inputChannelIdSolo')"
        /> -->
        <el-select
          v-model="form.channelId"
          filterable
          clearable
          :placeholder="$t('message.chooseOne')"
        >
          <el-option :label="$t('option.all')" value="" />
          <el-option
            v-for="item in payOption"
            :key="item.channelId"
            :label="item.channelId + ' - ' + item.channelName"
            :value="item.channelId"
          />
        </el-select>
      </el-form-item>
<!--      <el-form-item :label="$t('text.startTime')" prop="startTime">-->
<!--        <el-input-->
<!--          v-model="form.startTime"-->
<!--          auto-complete="off"-->
<!--          :placeholder="$t('message.inputTimeToMinute')"-->
<!--          class="time-input"-->
<!--        >-->
<!--         <template slot="append">/{{$t('text.minute')}}</template> -->
<!--        </el-input>-->
<!--      </el-form-item>-->

<!--      <el-form-item :label="$t('text.endTime')" prop="endTime">-->
<!--        <el-input-->
<!--          class="time-input"-->
<!--          v-model="form.endTime"-->
<!--          auto-complete="off"-->
<!--          :placeholder="$t('message.inputTimeToMinute')"-->
<!--        >-->
<!--        <template slot="append">/{{$t('text.minute')}}</template> -->
<!--       </el-input>-->
<!--      </el-form-item>-->
      <el-form-item
          :label="$t('text.submittedTime')"
          prop="submitDateTimeRange"
          :inline-message="true"
      >
        <el-date-picker
            v-model="submitDateTimeRange"
            type="datetimerange"
            format="yyyy-MM-dd HH:mm:ss"
            value-format="yyyy-MM-dd HH:mm:ss"
            :range-separator="$t('text.to')"
            :start-placeholder="$t('text.startTime')"
            :end-placeholder="$t('text.endTime')"
            @change="createTimeChange"
        />
      </el-form-item>
    </el-form>
    <div slot="footer" class="dialog-footer">
      <el-button @click="closeDialog" v-if="submitted === false">{{
        $t("text.cancel")
      }}</el-button>
      <el-button type="primary" @click="submit" v-if="submitted === false"
        >{{ $t("text.confirm") }}
      </el-button>
    </div>
  </el-dialog>
</template>

<script>
import moment from "moment/moment";

export default {
  props: {
    isShowSyncOrderStatusConfigDialog: {
      type: Boolean,
      default: false,
    },
  },
  data() {
    return {
      form: {
        // startTime: "10",
        // endTime: "60",
        startDateTime: "",
        endDateTime: "",
        upstream: "",
        channelId: "",
        type: "none",
      },
      submitDateTimeRange: null,
      // rules: {
      //   merchantUserId: [
      //     { required: true, message: this.$t("message.inputMerchantUserId") },
      //   ],
      //   anotherField: [
      //     {
      //       validator: this.validateMerchantFields,
      //       trigger: "blur",
      //     },
      //   ],
      // },
      loading: null,
      title: "",
      submitted: false,
      result: {
        success: false,
        message: "",
        link: "",
      },
      payOption:[]
    };
  },
  created() {
    this.$axios
      .get("/routeChannelInfo/selectByCondition", { params: {} })
      .then((res) => {
        this.payOption = res.data.filter(v=>v.productId === "110")
      });
  },
  methods: {
    createTimeChange(e) {
      if (e) {
        this.form.startDateTime = e[0];
        this.form.endDateTime = e[1];
      } else {
        this.form.startDateTime = "";
        this.form.endDateTime = "";
      }
    },
    lockDialog() {
      this.loading = this.$loading({
        lock: true,
        text: this.$t("text.loading"),
        spinner: "el-icon-loading",
        target: "#createTestCollectionOrderDialog .el-dialog",
      });
    },
    unlockDialog() {
      if (this.loading !== null) {
        this.loading.close();
      }
    },
    openDialog() {
      this.title = this.$t("text.testOrder");
      this.submitted = false;
      this.result = {
        success: false,
        message: "",
        link: "",
      };
      let start = moment().subtract(1, 'hours').format("YYYY-MM-DD HH:mm:ss");
      let end = moment().subtract(10, 'minutes').format("YYYY-MM-DD HH:mm:ss");
      this.form.startDateTime = start;
      this.form.endDateTime = end;
      this.submitDateTimeRange = [start, end];
    },
    closeDialog() {
      // this.form.merchantUserId = "";
      // this.form.orderId = "";
      // this.form.merchantOrderId = "";
      this.$refs.form.resetFields();
      this.$emit("update:isShowSyncOrderStatusConfigDialog", false);
    },
    submit() {
      this.$refs.form.validate((valid) => {
        if (valid) {
          this.lockDialog();
          this.$axios
            .post("/order/syncOrderStatusJob", this.form)
            .then((res) => {
              this.unlockDialog();
              if (res.code === 200) {
                this.$bus.$emit("refresh");
                this.closeDialog();
                this.$notify({
                  title: `${this.$t("text.operationSuccessful")}`,
                  message: res.msg,
                  type: "success",
                });
                return true;
              } else {
                this.$notify.error({
                  title: this.$t("text.prompt"),
                  message: res.msg,
                });
                return false;
              }
            })
            .catch(() => {
              this.unlockDialog();
              this.$notify.error({
                title: this.$t("text.prompt"),
                message: this.$t("message.sysError"),
              });
            });
        } else {
          return false;
        }
      });
    },
    // validateMerchantFields(rule, value, callback) {
    //   if (!this.form.orderId && !this.form.merchantOrderId) {
    //     callback(new Error(this.$t("message.inputOrderIdOrMerchantId")));
    //   } else {
    //     callback();
    //   }
    // },
    mounted() {
      this.openDialog();
    },
  },
};
</script>
<style lang="scss" scoped>
::v-deep.time-input {
   &.el-input-group--append {
      .el-input-group__append, .el-input-group__prepend  {
        background-color: transparent;
      }
      .el-input__inner {
       border-right: none;
    }
  }
}

</style>
